// extracted by mini-css-extract-plugin
module.exports = {"container":"page404_container__3SEqA","title":"page404_title__15Jwr","red":"page404_red__blJL_","btn":"page404_btn__2cIyI","link":"page404_link__2bbbG"};